<template>
  <div class="footer">
    <div class="footer-tab-item normal" @click="switchTo('/home', false)" :class="{active:'/home'===$route.path || '/'===$route.path}">
      <span class="icon-item icon-index"></span>
      <p class="footer-tab-item-p">首页</p>
    </div>
    <div class="footer-tab-item normal" @click="switchTo('/category', false)" :class="{active:'/category'===$route.path}">
      <span class="icon-item icon-category"></span>
      <p class="footer-tab-item-p">分类</p>
    </div>
      <div class="footer-tab-item normal" @click="switchTo('/grop-list', false)" :class="{active:'/grop-list'===$route.path}">
      <span class="icon-item icon-group"></span>
      <p class="footer-tab-item-p">拼团购</p>
    </div>
    <div class="footer-tab-item normal" @click="switchTo('/car', true)" :class="{active:'/car'===$route.path}">
      <span class="icon-item icon-car"></span>
      <p class="footer-tab-item-p">购物车</p>
    </div>
    <div class="footer-tab-item normal" @click="switchTo('/personal-center', false)" :class="{active:'/personal-center'===$route.path}">
      <span class="icon-item icon-user"></span>
      <p class="footer-tab-item-p">我</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0
    };
  },
  methods: {
    switchTo(path, flag){
      if (flag) {
        if(localStorage.getItem('userInfo')) {
          this.$router.replace(path)
        } else {
          this.$dialog.confirm({
            title: '登陆提醒',
            message: '当前操作需要登陆，是否前往登陆？'
          }).then(() => {
            this.$router.push({
              path: '/login'
            })
          }).catch(() => {

          });
        }
       
      } else {
        // console.log(path)
        this.$router.replace(path)
      }

    }
  }
};
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  max-width: 750px;
  // height: 100px;
  background: $bg02;
  border-top: 1px solid $bc01;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  visibility: visible;
  padding-bottom: env(safe-area-inset-bottom);
  .footer-tab-item {
    margin: 8px 0 10px;
    color: $fc01;
    flex: 1;
    line-height: 1;
    .footer-tab-item-p {
      font-size: 20px;
      margin-top: 10px;
    }
    .icon-item {
      width: 45px;
      height: 45px;
      display: inline-block;
    }

    &.normal {
      .icon-index {
        background: url("../assets/images/tabbar-home.png") no-repeat 0 -45px/100%;
      }
      .icon-category {
        background: url("../assets/images/tabbar-category.png") no-repeat 0 -45px/100%;
      }
      .icon-car {
        background: url("../assets/images/tabbar-car.png") no-repeat 0 -45px/100%;
      }
      .icon-group {
        background: url("../assets/images/group.png") no-repeat 0 -45px/100%;
      }
      .icon-user {
        background: url("../assets/images/tabbar-user.png") no-repeat 0 -45px/100%;
      }
      .footer-tab-item-p {
        color: $fc01;
      }
    }
    &.active {
      .icon-index {
        background: url("../assets/images/tabbar-home.png") no-repeat 0 0px/100%;
      }
      .icon-category {
        background: url("../assets/images/tabbar-category.png") no-repeat 0 0px/100%;
      }
      .icon-car {
        background: url("../assets/images/tabbar-car.png") no-repeat 0 0px/100%;
      }
       .icon-group {
        background: url("../assets/images/group.png") no-repeat 0 0px/100%;
      }
      .icon-user {
        background: url("../assets/images/tabbar-user.png") no-repeat 0 0px/100%;
      }
      .footer-tab-item-p {
        color: $fc07;
      }
    }
  }
}
</style>

